import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { twMerge } from 'tailwind-merge';
type SectionProps = {
  actions?: React.ReactNode;
  children: React.ReactNode;
  Icon?: Icon;
  title: string;
  testID?: string;
  className?: string;
};
const Section = t0 => {
  const $ = _c(17);
  const {
    title,
    Icon,
    actions,
    children,
    testID,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("px-5 py-4 border rounded bg-primary border-tertiary flex flex-col gap-5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== Icon) {
    t2 = Icon && <Icon />;
    $[2] = Icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== title) {
    t3 = <div className="flex items-center gap-1 text-label-2 text-primary">{t2}{title}</div>;
    $[4] = t2;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== actions || $[8] !== t3) {
    t4 = <header className="flex items-center justify-between">{t3}{actions}</header>;
    $[7] = actions;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== children) {
    t5 = <div className="flex flex-col gap-4">{children}</div>;
    $[10] = children;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t4 || $[14] !== t5 || $[15] !== testID) {
    t6 = <section className={t1} data-testid={testID}>{t4}{t5}</section>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
    $[15] = testID;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default Section;